import { useRef } from 'react';

export const useCachedNullableValue = <T>(value: T): [T, T] => {
  const valueKeeper = useRef<T>(value);
  if (value != null) {
    valueKeeper.current = value;
  }
  return [value, valueKeeper.current];
};
